export class AnalysesResponse {
    id?: number;
    testCode?: string;
    packageCode?: string;
    groupCode?: string;
    quotationLineCode?: string;
    invoiceableItemType?: InvoiceableItemType;
    referenceId?: string;
    structuredComment?: string;
    monographCode?: string;
    compendiumCode?: string;
    isMrt?: boolean;
    executionNumber?:number;
}

export enum InvoiceableItemType {
    None = 0,
    Test = 1,
    Package,
    TestQuotationLine,
    PackageQuotationLine,
    CustomerPackage,
}
